/**
 * Enum representing the possible directions of a step in a multistep process (e.g. pagination, carousel etc.)
 */
export enum StepDirectionEnum {
  NEXT = 'NEXT',
  PREVIOUS = 'PREVIOUS',
}
